<template src="./login-multi.html"></template>

<script>
import Vue from 'vue'
import { isAuth, isUserActive, setCredentials } from '@/router/auth'
import { EventBus } from '@/router/bus'

export default {
  name: 'login-multi',
  data () {
    return {
      loading: false,
      model: 'tab-1',
      tabs: null,
      user: {
        login: '',
        password: ''
      },
      emailRules: [
        v => !!v || this.$t('validation.emailRequired'),
        v => /.+@.+\..+/.test(v) || this.$t('validation.emailRequired')
      ],
      passwordRules: [
        v => !!v || this.$t('validation.passwordRequired')
      ]
    }
  },
  mounted () {
    if (isAuth() && isUserActive()) {
      this.goToDash()
    } else {
      this.$nextTick(() => this.$refs.usernameInput.focus())
    }
  },
  created () {
    this.$nextTick(() => this.$refs.usernameInput.focus())
  },
  methods: {
    login () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      const loginUrl = Vue.$apiConfig.login
      this.$http.post(loginUrl, this.user).then(
        response => {
          const data = response.data
          setCredentials(
            this.user.login,
            data.payload.accessToken,
            data.payload.refreshToken
          )
          this.loading = false
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect)
          } else {
            this.goToDash()
          }
          EventBus.$emit('logged-in', 'asd')
        },
        error => {
          this.loading = false
          this.logConsole(error)
          this.formatErrorResponse(error)
        })
    },
    forgottenPassword () {
      this.$router.push('/login/password-reset')
    },
    initialLogin () {
      this.$router.push('/login/initial')
    },
    goToDash () {
      this.$router.push('/dashboard')
    }
  }
}
</script>
